import { KeycloakGetResponse } from '@entities/User/types/kc.get'
import { UserFullInfo } from '@entities/User/types/user.fullInfo'

const getFirstAttributeValue = <T extends string>(value?: T[]): T | undefined => {
	return value?.[0]
}

const getNumberAttributeValue = (value?: string[]): number | undefined => {
	const rawValue = getFirstAttributeValue(value)

	if (rawValue === undefined || rawValue === '') {
		return undefined
	}

	const parsedValue = Number(rawValue)
	return Number.isNaN(parsedValue) ? undefined : parsedValue
}

export const mapKcToUserInfo = (kc: KeycloakGetResponse): Partial<UserFullInfo> => {
	const attributes: NonNullable<KeycloakGetResponse['attributes']> = kc.attributes ?? {}

	const userInfo: Partial<UserFullInfo> = {
		id: kc.id,
		username: kc.username,
		firstName: kc.firstName,
		lastName: kc.lastName,
		email: kc.email,
		birthday: getFirstAttributeValue(attributes.birthday),
		favoriteTrainingType: getFirstAttributeValue(attributes.favoriteTrainingType),
		contraindications: getFirstAttributeValue(attributes.contraindications),
		physique: getFirstAttributeValue(attributes.physique),
		trainingsPerWeek: getNumberAttributeValue(attributes.trainingsPerWeek),
		kilogramsDifferenceTarget: getNumberAttributeValue(attributes.kilogramsDifferenceTarget),
		fatnessLevel: getFirstAttributeValue(attributes.fatnessLevel),
		stressLevel: getFirstAttributeValue(attributes.stressLevel),
		weight: getNumberAttributeValue(attributes.weight),
		experienceLevel: getFirstAttributeValue(attributes.experienceLevel),
		caloriesPerDay: getNumberAttributeValue(attributes.caloriesPerDay),
		diet: getFirstAttributeValue(attributes.diet),
		healthInformation: getFirstAttributeValue(attributes.healthInformation),
		activityLevel: getFirstAttributeValue(attributes.activityLevel),
		height: getNumberAttributeValue(attributes.height),
		trainingTargets: attributes.trainingTargets,
		sex: getFirstAttributeValue(attributes.sex),
		language: getFirstAttributeValue(attributes.language),
		favoriteSport: getFirstAttributeValue(attributes.favoriteSport),
		yearsExperience: getNumberAttributeValue(attributes.yearsExperience),
		avatarUrl: getFirstAttributeValue(attributes.avatarUrl),
	}

	return Object.fromEntries(
		Object.entries(userInfo).filter(([, value]) => value !== undefined)
	) as Partial<UserFullInfo>
}
